"use strict";

import {
  Badge,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputBase,
  InputLabel,
  MenuItem,
  Rating,
  Select,
} from "@mui/material";
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useContext,
  useMemo,
} from "react";
import classes from "../../Assets/Styles/VoiceQAScreen.module.css";
import {
  formatInputs,
  parseTimestampAsTotalSeconds,
} from "../../utils/generalFunctions";
import {
  ensureProjectFinalLanguageTranslations,
  findTranslationByLanguageCode,
  getDefaultVoiceIdForEmotion,
  getRecommendedSpeedOption as getProjectWorkRecommendedSpeedOption,
  getSpeakerDisplayName,
  getTranslationDurationMessage,
} from "../../features/projectWork";

import Loader from "../../Components/Loader";
import axios from "axios";
import { Store } from "../../Store";
import {
  CREATE_NEW_AUDIO,
  GENERATE_SOUND_EFFECT,
  UPDATE_ONE_SPEECH,
  GET_CHARACTERS_FOR_PROJECT,
  GET_SPEECH_FOR_PROJECT_BY_PAGE,
  CREATE_MULTIPLE_AUDIO,
  GET_SPEECH_POSITION_AROUND_TIME,
  SET_DIALOGUE_APPROVAL_STATUS,
  MERGING_FULL_API,
  ADJUST_AUDIO_SPEED,
  ADJUST_AUDIO_SPEED_AUTO,
  SEARCH_SPEECH_FOR_PROJECT,
} from "../../ApiEndpoints";
import { ToastContainer, toast } from "react-toastify";
import { useMediaQuery } from "@mui/material";
import ReactAudioPlayer from "react-audio-player";
import PerformanceVideoPlayer from "../../Components/Players/PerformanceVideoPlayer";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useParams } from "react-router-dom";

import { secondaryColor } from "../../utils/constants";
import TaskButton from "../../Components/Buttons/TaskButton";

import {
  DEFAULT_VOICE_ENGINE,
  LEGACY_AUDIO_ENGINE_LABEL,
  SOUND_EFFECT_VOICE_ENGINE,
  VOICE_ENGINE_OPTIONS,
  getSupportedVoiceEngine,
  isLegacyVoiceEngine,
  isSupportedVoiceEngine,
} from "../../Data/voiceEngines";

import ClipLoader from "react-spinners/ClipLoader";
import ClipAudioPlayer from "../../Components/Players/ClipAudioPlayer";
import styled from "styled-components";
import InputMask from "react-input-mask";
import debounce from "lodash.debounce";

import { useExperimentalFeature } from "../../utils/featureAccess";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import VolumeSelector from "../../Components/AudioTools/VolumeSelector";

import DialogueSearchFilter, {
  DEFAULT_DIALOGUE_SEARCH_FILTERS,
  hasAnyDialogueSearchFilter,
} from "../../Components/DialogueSearchFilter/DialogueSearchFilter";
import { injectToken } from "../../utils/injectToken";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {},
  "& .MuiInputBase-input": {
    width: "0px",
    borderRadius: "var(--radius-md)",
    position: "relative",
    backgroundColor: "none",
    border: "none",
    fontSize: "var(--font-size-normal)",
    padding: "6px 20px 6px 12px",
    color: "var(--color-table-header-text)",
  },
}));

const BootstrapInputForAvalialbe = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    color: "var(--color-table-header-text)",
    width: "100%",
    position: "relative",
    backgroundColor: "none",
    border: "none",
    fontSize: "var(--font-size-normal)",
  },
}));

const VideoPerformanceDirection = () => {
  const params = useParams();
  const { language: languageCode } = params;
  const screenIsOver1200px = useMediaQuery("(min-width: 1200px)");
  const translatedAudioRefs = useRef([]);
  const originalAudioRefs = useRef([]);

  const { state } = useContext(Store);
  const { projectFile, userInfo } = state;

  const videoUrl =
    projectFile?.videoUrl || projectFile?.fileUrl || projectFile?.video || "";

  const originalLanguageCode =
    projectFile?.originalLanguage ||
    projectFile?.orginalLang ||
    projectFile?.orgLang ||
    projectFile?.org_lang ||
    projectFile?.sourceLanguageCode ||
    projectFile?.sourceLanguage ||
    "";

  const [characters, setCharacters] = useState([]);
  const [audioData, setAudioData] = useState([]);
  const [currentTime, setCurrentTime] = useState(0);
  const [seekTime, setSeekTime] = useState(0);
  const [seekTimeIndex, setSeekTimeIndex] = useState(0);
  const [scrollableItem, setScrollableItem] = useState(0);
  const [scrollableItemLastUpdated, setScrollableItemLastUpdated] = useState(0);
  const [audioLoader, setAudioLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [versionName, setVersionName] = useState("");

  const [currentContinuousSync, setCurrentContinuousSync] = useState();
  const [syncPreview, setSyncPreview] = useState(false);

  const [playPausePlayer, setPlayPausePlayer] = useState("pause");
  const [manualPauseTick, setManualPauseTick] = useState(0);
  const [currentlyPlayingId, setCurrentlyPlayingId] = useState(null);

  const numberOfDialogues = projectFile?.numberOfDialogues || 0;

  const timeoutIdRef = useRef(null);

  const [globalEmotions, setGlobalEmotions] = useState({});
  const experimentalTraining = useExperimentalFeature(
    projectFile?.id,
    userInfo?.id,
    projectFile?.name
  );

  const [pageButtonActivity, setPageButtonActivity] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [goToPageNumber, setGoToPageNumber] = useState("");

  const [dialogueSearchFilters, setDialogueSearchFilters] = useState(
    DEFAULT_DIALOGUE_SEARCH_FILTERS
  );
  const [isDialogueSearchActive, setIsDialogueSearchActive] = useState(false);
  const [searchResultCount, setSearchResultCount] = useState(0);

  const [inputStartTime, setInputStartTime] = useState({});
  const [inputEndTime, setInputEndTime] = useState({});
  const [subtitleOnlyMap, setSubtitleOnlyMap] = useState({});
  const [vEngineTypeMap, setVEngineTypeMap] = useState({});
  const [performanceCollapsedMap, setPerformanceCollapsedMap] = useState({});
  const [speedSelectionMap, setSpeedSelectionMap] = useState({});

  const itemsPerPage = 10;

  const activeDialogueCount = isDialogueSearchActive
    ? searchResultCount
    : numberOfDialogues;

  const totalPages = Math.max(1, Math.ceil(activeDialogueCount / itemsPerPage));

  const containerRef = useRef(null);
  const performanceToggleButtonWidth = "110px";

  useEffect(() => {
    const fetchEmotions = async () => {
      if (!experimentalTraining) return;

      try {
        const db = getFirestore();
        const emotionsRef = doc(db, "EmotionMappings", "global-dec-2024");
        const emotionsSnap = await getDoc(emotionsRef);

        if (emotionsSnap.exists()) {
          setGlobalEmotions(emotionsSnap.data());
        } else {
          console.log("No emotion mappings found");
        }
      } catch (err) {
        console.error("Error fetching emotion mappings:", err);
      }
    };

    fetchEmotions();
  }, [experimentalTraining]);

  const scrollToItem = (index) => {
    const manpIndex = index;

    if (containerRef.current) {
      const item = containerRef.current.children[manpIndex];
      if (item) {
        item.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  const displayAudioTime = useCallback((data) => {
    setCurrentTime(data);
  }, []);

  function findDisplayName(speaker) {
    return getSpeakerDisplayName(characters, speaker);
  }

  const originalAudioEmotionOptions = useMemo(() => {
    const emotionsFromLoadedDialogues = audioData
      .map((dialogue) => dialogue?.originalAudioEmotion)
      .filter(Boolean);

    const emotionsFromCharacterVoices = characters
      .flatMap((character) => character?.voices || [])
      .map((voice) => voice?.emotion)
      .filter(Boolean);

    return [
      ...new Set([
        "neutral",
        ...emotionsFromLoadedDialogues,
        ...emotionsFromCharacterVoices,
      ]),
    ];
  }, [audioData, characters]);

  const checkTimeInRange = useCallback(
    (currentTimeValue) => {
      if (!audioData) {
        return;
      }

      const numericTime = Number(currentTimeValue);

      if (Number.isNaN(numericTime)) {
        return;
      }

      let itemInTimeRange = null;

      for (const item of audioData) {
        const start = Number(item.start);
        const end = Number(item.end);

        if (Number.isNaN(start) || Number.isNaN(end)) {
          continue;
        }

        if (numericTime >= start && numericTime < end) {
          if (!itemInTimeRange || Number(itemInTimeRange.start) < start) {
            itemInTimeRange = item;
          }
        }
      }

      if (itemInTimeRange) {
        if (itemInTimeRange.id !== scrollableItemLastUpdated) {
          setScrollableItemLastUpdated(itemInTimeRange.id);
          setScrollableItem(itemInTimeRange.id);
          setCurrentContinuousSync(itemInTimeRange);
        }
      }
    },
    [audioData, scrollableItemLastUpdated]
  );

  useEffect(() => {
    checkTimeInRange(currentTime);
  }, [currentTime, checkTimeInRange]);

  useEffect(() => {
    if (false) {
      if (screenIsOver1200px) {
        scrollToItem(scrollableItem - 1);
      }
    }
  }, [scrollableItem, screenIsOver1200px]);

  const findDefaultEmotion = useCallback(
    (speaker, originalAudioEmotion) => {
      if (experimentalTraining) {
        console.log(
          `used experimental ${globalEmotions[originalAudioEmotion]}`
        );
        return (
          globalEmotions[originalAudioEmotion] ||
          globalEmotions["neutral"] ||
          "dwo0oupDDyJeTBpyE6n3"
        );
      }

      console.log("didn't use experimental");

      return getDefaultVoiceIdForEmotion(
        projectFile?.characters,
        speaker,
        originalAudioEmotion
      );
    },
    [experimentalTraining, globalEmotions, projectFile?.characters]
  );

  function checkTranslationLength(originalLength, translatedLength) {
    return getTranslationDurationMessage(originalLength, translatedLength);
  }

  function getRecommendedSpeedOption(originalLength, translatedLength) {
    return getProjectWorkRecommendedSpeedOption(originalLength, translatedLength);
  }

  const checkLanguage = useCallback(
    (translations = []) => {
      return ensureProjectFinalLanguageTranslations(
        translations,
        projectFile?.finalLang
      );
    },
    [projectFile?.finalLang]
  );

  const findTransObjectsbyLangCode = useCallback(
    (array = []) => findTranslationByLanguageCode(array, languageCode),
    [languageCode]
  );

  const prepareDialogues = useCallback(
    (dialogues = []) => {
      const subtitleMap = {};
      const performanceMap = {};
      const engineMap = {};
      const speedMap = {};

      const hydratedDialogues = dialogues.map((dia, index) => {
        const translations = checkLanguage(dia.translations);
        const selectedTranslation = findTransObjectsbyLangCode(translations);

        const initialVoiceEngine =
          selectedTranslation?.translatedAudioLastUsedModel ||
          dia.translatedAudioLastUsedModel ||
          dia.vEngineType ||
          DEFAULT_VOICE_ENGINE;

        subtitleMap[dia.dbid] = dia.subtitleOnly === true;
        performanceMap[dia.dbid] = dia.approved === true;
        engineMap[dia.dbid] = initialVoiceEngine;
        speedMap[dia.dbid] = "";

        return {
          ...dia,
          id: index,
          vEngineType: initialVoiceEngine,
          tempTransEmotion: findDefaultEmotion(
            dia.speaker,
            dia.originalAudioEmotion
          ),
          translatedAudioDurationTemp: null,
          record: false,
          translations,
          filterShow: true,
          loader: false,
          tempAudioList: selectedTranslation?.translatedAudio
            ? [
                {
                  url: selectedTranslation.translatedAudio,
                  length: selectedTranslation.translatedAudioDuration,
                  emotion: "original",
                },
              ]
            : [],
        };
      });

      setSubtitleOnlyMap(subtitleMap);
      setPerformanceCollapsedMap(performanceMap);
      setVEngineTypeMap(engineMap);
      setSpeedSelectionMap(speedMap);

      return hydratedDialogues;
    },
    [checkLanguage, findDefaultEmotion, findTransObjectsbyLangCode]
  );

  const findEmotionByVoiceId = (voiceId) => {
    if (experimentalTraining) {
      for (let currEmotion in globalEmotions) {
        if (globalEmotions[currEmotion] === voiceId) {
          return currEmotion;
        }
      }
    }

    for (const character of characters) {
      if (!character.voices || character.voices.length === 0) continue;

      for (const voice of character.voices) {
        if (voice.voice_id === voiceId) {
          return voice.emotion;
        }
      }
    }

    return null;
  };

  const handleVoiceOverLapping = (index, originalDuration) => {
    const updatedData = [...audioData];
    const endTime = updatedData[index].start + originalDuration;
    const startTime = updatedData[index + 1]?.start;

    return endTime >= startTime ? <>{" Overlapping "}</> : "";
  };

  const handleSpeakerChange = async (e, index) => {
    setAudioLoader(true);

    const updatedData = [...audioData];

    updatedData[index] = {
      ...updatedData[index],
      speaker: e.target.value,
    };

    setAudioData(updatedData);

    try {
      const response = await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });

      if (response.data) {
        setAudioData(updatedData);
        setAudioLoader(false);
      }
    } catch (err) {
      console.log(err);
      setAudioLoader(false);
    }
  };

  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    const milliseconds = Math.round((timeInSeconds % 1) * 100);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}.${String(milliseconds).padStart(
      2,
      "0"
    )}`;
  };

  useEffect(() => {
    const initialStartTimes = {};
    const initialEndTimes = {};

    audioData.forEach((data, index) => {
      initialStartTimes[index] = formatTime(data.start || 0);
      initialEndTimes[index] = formatTime(data.end || 0);
    });

    setInputStartTime(initialStartTimes);
    setInputEndTime(initialEndTimes);
  }, [audioData]);

  const saveStartTime = useMemo(
    () =>
      debounce(async (data) => {
        try {
          await axios.post(UPDATE_ONE_SPEECH, {
            projectId: projectFile?.id,
            dialogue: data,
          });
        } catch (error) {
          console.error("Error saving start time:", error);
        }
      }, 500),
    [projectFile?.id]
  );

  const saveEndTime = useMemo(
    () =>
      debounce(async (data) => {
        try {
          await axios.post(UPDATE_ONE_SPEECH, {
            projectId: projectFile?.id,
            dialogue: data,
          });
        } catch (error) {
          console.error("Error saving end time:", error);
        }
      }, 500),
    [projectFile?.id]
  );

  useEffect(() => {
    return () => {
      saveStartTime.cancel?.();
      saveEndTime.cancel?.();
    };
  }, [saveEndTime, saveStartTime]);

  const handleStartTimeChange = (e, index) => {
    const value = e.target.value;

    setInputStartTime((prev) => ({ ...prev, [index]: value }));

    const newTime = parseTimestampAsTotalSeconds(value);
    const updatedData = [...audioData];

    updatedData[index] = { ...updatedData[index], start: newTime };

    setAudioData(updatedData);
    saveStartTime(updatedData[index]);
  };

  const handleEndTimeChange = (e, index) => {
    const value = e.target.value;

    setInputEndTime((prev) => ({ ...prev, [index]: value }));

    const newTime = parseTimestampAsTotalSeconds(value);
    const updatedData = [...audioData];

    updatedData[index] = { ...updatedData[index], end: newTime };

    setAudioData(updatedData);
    saveEndTime(updatedData[index]);
  };

  const getDialogueDurationSeconds = (dialogue) => {
    if (!dialogue) {
      return Number.NaN;
    }

    const rawDuration = Number(dialogue.duration);

    if (!Number.isNaN(rawDuration) && rawDuration > 0) {
      return rawDuration;
    }

    const startSeconds =
      typeof dialogue.start === "number"
        ? dialogue.start
        : parseTimestampAsTotalSeconds(dialogue.start) || 0;

    const endSeconds =
      typeof dialogue.end === "number"
        ? dialogue.end
        : parseTimestampAsTotalSeconds(dialogue.end) || 0;

    const computedDuration = endSeconds - startSeconds;

    return computedDuration > 0 ? computedDuration : Number.NaN;
  };

  function handleNoteChange(e, index) {
    const updatedData = [...audioData];

    updatedData[index].translations = updatedData[index].translations.map(
      (prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            translatedAudioNote: e.target.value,
          };
        }

        return prev;
      }
    );

    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);

    setAudioData(updatedData);
  }

  function handleTextChange(e, index) {
    const updatedData = [...audioData];

    updatedData[index] = {
      ...updatedData[index],
      text: e.target.value,
    };

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);
  }

  function handleTranslationChange(e, index) {
    const updatedData = [...audioData];

    updatedData[index].translations = updatedData[index].translations.map(
      (prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            translatedText: e.target.value,
          };
        }

        return prev;
      }
    );

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);
  }

  function handleTextFocus(index, startTime) {
    const startSeconds =
      typeof startTime === "number"
        ? startTime
        : parseTimestampAsTotalSeconds(startTime) || 0;

    setSeekTime(startSeconds);
    setSeekTimeIndex((prev) => prev + 1);

    const originalPlayer = originalAudioRefs.current[index];

    if (originalPlayer?.audioEl?.current) {
      originalPlayer.audioEl.current.pause();
      originalPlayer.audioEl.current.currentTime = 0;
    }

    const translatedPlayer = translatedAudioRefs.current[index];

    if (translatedPlayer) {
      if (typeof translatedPlayer.pause === "function") {
        translatedPlayer.pause();
      }

      if (typeof translatedPlayer.seek === "function") {
        translatedPlayer.seek(0);
      }
    }

    if (!syncPreview) {
      requestSyncPause();
      setManualPauseTick((prev) => prev + 1);
      return;
    }

    const shouldResumePlayback = playPausePlayer === "play";

    if (!shouldResumePlayback) {
      requestSyncPause();
      setPlayPausePlayer("pause");
      return;
    }

    if (
      currentlyPlayingId !== null &&
      currentlyPlayingId !== undefined &&
      playRow(index)
    ) {
      setPlayPausePlayer("play");
      return;
    }

    requestSyncPlay();
  }

  const handleDialogueRating = async (rating, index) => {
    setAudioLoader(true);

    const updatedData = [...audioData];

    updatedData[index].translations = updatedData[index].translations.map(
      (prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            translatedAudioRating: rating,
          };
        }

        return prev;
      }
    );

    try {
      const response = await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });

      if (response.data) {
        setAudioData(updatedData);
        setAudioLoader(false);
      }
    } catch (err) {
      console.log(err);
      setAudioLoader(false);
    }
  };

  const handleNewAudioUrl = async (index) => {
    const now = new Date();
    const storedVoiceEngine =
      vEngineTypeMap[audioData[index].dbid] || DEFAULT_VOICE_ENGINE;
    if (isLegacyVoiceEngine(storedVoiceEngine)) {
      toast.error(
        "Legacy audio remains playable, but generation with this legacy engine is no longer available. Select a supported voice engine to create new audio."
      );
      return;
    }

    const selectedVoiceEngine = getSupportedVoiceEngine(storedVoiceEngine);

    const isSoundEffectEngine =
      selectedVoiceEngine === SOUND_EFFECT_VOICE_ENGINE;

    if (!isSoundEffectEngine && audioData[index].tempTransEmotion === "") {
      toast.error("Error !! Choose an emotion");
      return;
    }

    const dialogueCopy = {
      ...audioData[index],
      translatedText: findTransObjectsbyLangCode(audioData[index].translations)
        .translatedText,
      languageCode: languageCode,
      loader: false,
      vEngineType: selectedVoiceEngine,
    };

    if (!isSoundEffectEngine) {
      dialogueCopy.voiceId = audioData[index].tempTransEmotion;
      dialogueCopy.emotion = findEmotionByVoiceId(
        audioData[index].tempTransEmotion
      );
    } else {
      dialogueCopy.voiceId = null;
      dialogueCopy.emotion = null;
    }

    const targetDurationSeconds = getDialogueDurationSeconds(dialogueCopy);

    const requestBody = isSoundEffectEngine
      ? {
          projectId: projectFile.id,
          dialogueID: audioData[index].dbid,
          prompt_influence: 0.5,
          vEngineType: SOUND_EFFECT_VOICE_ENGINE,
          dialogue: dialogueCopy,
        }
      : {
          dialogue: dialogueCopy,
          projectName: projectFile.name,
          creationDate: projectFile.creationDate,
          projectId: projectFile.id,
          targetDuration: targetDurationSeconds,
          vEngineType: selectedVoiceEngine,
        };

    const hasRequiredFields = isSoundEffectEngine
      ? requestBody.dialogue && requestBody.projectId && requestBody.dialogueID
      : requestBody.dialogue &&
        requestBody.projectId &&
        requestBody.projectName;

    if (!hasRequiredFields) {
      toast.error("Missing data required to create new audio");
      return;
    }

    try {
      const endpoint = isSoundEffectEngine
        ? GENERATE_SOUND_EFFECT
        : CREATE_NEW_AUDIO;

      const headers = await injectToken();
      console.log("Headers:", headers);

      // const response = await axios.post(endpoint, requestBody);
      const response = await axios.post(endpoint, requestBody, {
        headers,
      });
      // const response = await fetch(endpoint, {
      //                 method: "POST",
      //                 headers: await injectToken(userInfo.id),
      //                 body: JSON.stringify(requestBody),
      //             });

      const newAudioObject = {
        url: response.data.url,
        creationTime: now,
        emotion: isSoundEffectEngine ? null : audioData[index].tempTransEmotion,
        translatedAudioDuration: response.data.length,
      };

      dialogueCopy.translations = dialogueCopy.translations.map((prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            translatedAudio: newAudioObject.url,
            translatedAudioDuration: newAudioObject.translatedAudioDuration,
            translatedAudioList: prev.translatedAudioList
              ? [...prev.translatedAudioList, newAudioObject]
              : [newAudioObject],
          };
        }

        return prev;
      });

      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: dialogueCopy,
      });

      const newSingleAudio = {
        url: response.data.url,
        length: response.data.length,
        emotion: response.data.emotion,
      };

      setAudioData((prevData) => {
        const updatedData = [...prevData];

        const updatedTempAudioList = [
          ...updatedData[index].tempAudioList,
          newSingleAudio,
        ];

        updatedData[index] = {
          ...dialogueCopy,
          tempAudioList: updatedTempAudioList,
        };

        return updatedData;
      });

      toast.success("New Audio has been added", {
        hideProgressBar: false,
        autoClose: 1000,
      });
    } catch (err) {
      console.error(err);
      toast.error("Error in creating new audio");

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index].loader = false;
        return updatedData;
      });
    }
  };

  const handleMultipleAudio = async (index) => {
    if (audioData[index].tempTransEmotion === "") {
      toast.error("Error !! Choose an emotion");
      return;
    }

    const storedVoiceEngine =
      vEngineTypeMap[audioData[index].dbid] || DEFAULT_VOICE_ENGINE;
    if (isLegacyVoiceEngine(storedVoiceEngine)) {
      toast.error(
        "Legacy audio remains playable, but generation with this legacy engine is no longer available. Select a supported voice engine to create multiple takes."
      );
      return;
    }

    const selectedVoiceEngine = getSupportedVoiceEngine(storedVoiceEngine);

    if (selectedVoiceEngine === SOUND_EFFECT_VOICE_ENGINE) {
      toast.error(
        "Multiple takes are not available for the selected voice engine"
      );
      return;
    }

    const dialogueCopy = {
      ...audioData[index],
      translatedText: findTransObjectsbyLangCode(audioData[index].translations)
        .translatedText,
      voiceId: audioData[index].tempTransEmotion,
      languageCode: languageCode,
      emotion: findEmotionByVoiceId(audioData[index].tempTransEmotion),
      loader: false,
      vEngineType: selectedVoiceEngine,
    };

    const targetDurationSeconds = getDialogueDurationSeconds(dialogueCopy);

    const requestBody = {
      dialogue: dialogueCopy,
      projectName: projectFile.name,
      creationDate: projectFile.creationDate,
      projectId: projectFile.id,
      targetDuration: targetDurationSeconds,
      vEngineType: selectedVoiceEngine,
    };

    if (
      !requestBody.dialogue ||
      !requestBody.projectId ||
      !requestBody.projectName
    ) {
      toast.error("Missing data required to create multiple audio takes");
      return;
    }

    try {
      const headers = await injectToken();

      const response = await axios.post(CREATE_MULTIPLE_AUDIO, requestBody, {
        headers,
      });

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        const existingAudioList = updatedData[index].tempAudioList;

        const newAudioList = response.data.filter(
          (newAudio) =>
            !existingAudioList.some(
              (existingAudio) => existingAudio.url === newAudio.url
            )
        );

        updatedData[index].tempAudioList = [
          ...existingAudioList,
          ...newAudioList,
        ];
        updatedData[index].loader = false;

        return updatedData;
      });

      toast.success("New audio list has been added", {
        hideProgressBar: false,
        autoClose: 1000,
      });
    } catch (err) {
      console.error(err);
      toast.error("Error in creating new audio");

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index].loader = false;
        return updatedData;
      });
    }
  };

  const selectAudioOption = async (e, index, playerIndex) => {
    const now = new Date();
    const audioUrl = e.target.value;

    if (audioUrl === "") {
      toast.error("Select an audio!");
      return;
    }

    const audioDuration = audioData[index].tempAudioList.find(
      (audio) => audio.url === audioUrl
    ).length;

    const dialogueCopy = audioData[index];

    const newAudioObject = {
      url: audioUrl,
      translatedAudioDuration: audioDuration,
      creationTime: now,
      emotion: audioData[index].tempTransEmotion,
    };

    dialogueCopy.translations = dialogueCopy.translations.map((prev) => {
      if (prev.languageCode === languageCode) {
        return {
          ...prev,
          translatedAudio: newAudioObject.url,
          translatedAudioDuration: newAudioObject.translatedAudioDuration,
        };
      }

      return prev;
    });

    try {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: dialogueCopy,
      });

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index] = dialogueCopy;
        return updatedData;
      });

      setTimeout(() => {
        if (translatedAudioRefs.current[playerIndex]) {
          translatedAudioRefs.current[playerIndex].seek(0);
          translatedAudioRefs.current[playerIndex].play();
        }
      }, 1000);

      toast.info(" Audio has been updated", {
        hideProgressBar: false,
        autoClose: 1000,
      });
    } catch (error) {
      console.error(error);

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index].loader = false;
        return updatedData;
      });
    }
  };

  const handleAdjustSpeed = async (dialogue, requestedSpeed) => {
    if (!dialogue) {
      toast.error("Dialogue details are not available.");
      return;
    }

    if (!projectFile?.name) {
      toast.error("Project name is required to adjust audio speed.");
      return;
    }

    const selectedSpeed =
      requestedSpeed || speedSelectionMap[dialogue.dbid] || "auto";

    const dialogueWithLanguageCode = {
      ...dialogue,
      languageCode: dialogue.languageCode || languageCode,
    };

    try {
      setAudioLoader(true);

      let response;

      if (selectedSpeed === "auto") {
        response = await axios.post(ADJUST_AUDIO_SPEED_AUTO, {
          dialogue: dialogueWithLanguageCode,
          projectName: projectFile.name,
        });
      } else {
        response = await axios.post(ADJUST_AUDIO_SPEED, {
          dialogue: dialogueWithLanguageCode,
          projectName: projectFile.name,
          speed: selectedSpeed,
        });
      }

      const adjustedAudioUrl =
        response?.data?.url ||
        response?.data?.audioUrl ||
        response?.data?.translatedAudio ||
        response?.data?.dialogue?.translatedAudio ||
        response?.data?.dialogue?.translation?.translatedAudio ||
        response?.data?.dialogue?.translation?.url ||
        null;

      let dialogueToPersist = dialogue;

      if (adjustedAudioUrl) {
        setAudioData((prevData) => {
          let matchedRow = null;

          const updatedData = prevData.map((row) => {
            if (row.dbid !== dialogue.dbid) {
              return row;
            }

            const adjustedAudioEntry = {
              url: adjustedAudioUrl,
              length:
                response?.data?.length ||
                response?.data?.translatedAudioDuration ||
                response?.data?.duration ||
                null,
              emotion: `${selectedSpeed}x`,
            };

            const updatedTempAudioList = row.tempAudioList.some(
              (audio) => audio.url === adjustedAudioEntry.url
            )
              ? row.tempAudioList
              : [...row.tempAudioList, adjustedAudioEntry];

            const updatedTranslations = row.translations.map((translation) =>
              translation.languageCode === languageCode
                ? {
                    ...translation,
                    translatedAudio: adjustedAudioUrl,
                    translatedAudioDuration:
                      adjustedAudioEntry.length ||
                      translation.translatedAudioDuration,
                  }
                : translation
            );

            matchedRow = {
              ...row,
              tempAudioList: updatedTempAudioList,
              translations: updatedTranslations,
            };

            return matchedRow;
          });

          dialogueToPersist = matchedRow || dialogueToPersist;

          return updatedData;
        });
      }

      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: dialogueToPersist,
      });

      toast.success(
        `Requested ${
          selectedSpeed === "auto" ? "automatic" : `${selectedSpeed}x`
        } speed adjustment.`
      );
    } catch (error) {
      console.error("Error adjusting audio speed:", error);
      toast.error(
        error.response?.data?.message || "Failed to adjust audio speed."
      );
    } finally {
      setAudioLoader(false);
    }
  };

  const handleTranslatedAudioVolume = async (e, index) => {
    const dialogueCopy = audioData[index];

    let volume;
    const data = e.target.value;

    if (data === null || data === "") {
      volume = null;
    } else if (isNaN(data)) {
      volume = null;
    } else {
      volume = Number(data);
    }

    dialogueCopy.translations = dialogueCopy.translations.map((prev) => {
      if (prev.languageCode === languageCode) {
        return {
          ...prev,
          translatedAudioVolume: volume,
        };
      }

      return prev;
    });

    try {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: dialogueCopy,
      });

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index] = dialogueCopy;
        return updatedData;
      });

      toast.info(" Audio has been updated", {
        hideProgressBar: false,
        autoClose: 1000,
      });
    } catch (error) {
      console.error(error);

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        return updatedData;
      });
    }
  };

  const handleKeepOriginalText = async (index) => {
    setAudioLoader(true);

    const updatedData = [...audioData];

    updatedData[index] = {
      ...updatedData[index],
      keepOriginalText: !updatedData[index].keepOriginalText,
    };

    setAudioData(updatedData);

    try {
      const response = await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });

      if (response.data) {
        setAudioData(updatedData);
        setAudioLoader(false);
      }
    } catch (err) {
      console.log(err);
      setAudioLoader(false);
    }
  };

  const finalSubmission = async () => {
    if (!versionName) {
      toast.error("Enter an version name");
      return;
    }

    try {
      await axios.post(MERGING_FULL_API, {
        projectId: projectFile.id,
        projectName: projectFile.name,
        langCode: languageCode,
        version: versionName,
        emails: [userInfo.email, "bg@y76.io", "clifford@dubfrog.media"],
        submitterName: userInfo.name,
      });

      toast.success("New version is being processed");
      setVersionName("");
    } catch (err) {
      console.log(err);
      toast.error(err.response?.data?.error || "Error submitting version");
    }
  };

  const stopCurrentPageAudio = useCallback(() => {
    translatedAudioRefs.current.forEach((audioEl) => {
      if (audioEl?.pause) {
        audioEl.pause();
      }

      if (audioEl?.seek) {
        audioEl.seek(0);
      }
    });

    originalAudioRefs.current.forEach((audioEl) => {
      const player = audioEl?.audioEl?.current;

      if (player) {
        player.pause();
        player.currentTime = 0;
      }
    });

    setCurrentlyPlayingId(null);
    setPlayPausePlayer("pause");
  }, []);

  const getDialoguesFromResponse = (responseData) => {
    return (
      responseData?.projectsArray ||
      responseData?.dialogues ||
      responseData?.results ||
      []
    );
  };

  const getDialogueCountFromResponse = (responseData, fallbackCount) => {
    return Number(
      responseData?.totalCount ??
        responseData?.count ??
        responseData?.numberOfDialogues ??
        fallbackCount ??
        0
    );
  };

  const loadSearchDialoguesPage = useCallback(
    async (filters, targetPageNumber = 1) => {
      if (!projectFile?.id || !userInfo?.id) {
        return;
      }

      setLoader(true);
      setPageButtonActivity(true);

      try {
        stopCurrentPageAudio();

        const response = await axios.post(SEARCH_SPEECH_FOR_PROJECT, {
          userId: userInfo.id,
          projectId: projectFile.id,
          // languageCode,
          // originalLanguageCode,
          pageName: "voiceqa",
          pageNumber: Number(targetPageNumber),
          itemsPerPage,
          searchText: filters.searchText?.trim() || "",
          languageCode: filters.searchIn || "all",
          speaker: filters.speaker || "",
          originalAudioEmotion: filters.originalAudioEmotion || "",
          hasTranslatedAudio: filters.hasTranslatedAudio || "",
        });

        const dialogues = getDialoguesFromResponse(response.data);
        const totalCount = getDialogueCountFromResponse(
          response.data,
          dialogues.length
        );

        setAudioData(prepareDialogues(dialogues));
        setSearchResultCount(totalCount);
        setIsDialogueSearchActive(hasAnyDialogueSearchFilter(filters));
        setPageNumber(Number(targetPageNumber));
        setGoToPageNumber("");
      } catch (err) {
        console.error(err);
        toast.error("Error in searching dialogues");
      } finally {
        setLoader(false);
        setPageButtonActivity(false);
      }
    },
    [projectFile?.id, prepareDialogues, stopCurrentPageAudio, userInfo?.id]
  );

  const loadFirstDialoguePage = useCallback(async () => {
    if (!projectFile?.id || !userInfo?.id) {
      return;
    }

    setLoader(true);

    try {
      stopCurrentPageAudio();

      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: "first",
        Current: null,
        pageName: "voiceqa",
      });

      const dialogues = await response.data.projectsArray;

      setAudioData(prepareDialogues(dialogues));
      setPageNumber(1);
      setGoToPageNumber("");
    } catch (err) {
      console.log(err);
      toast.error("Error in getting dialogues");
    } finally {
      setLoader(false);
    }
  }, [prepareDialogues, projectFile?.id, stopCurrentPageAudio, userInfo?.id]);

  const handleDialogueSearch = async (filters) => {
    const normalizedFilters = {
      ...DEFAULT_DIALOGUE_SEARCH_FILTERS,
      ...filters,
      searchText: filters.searchText?.trim() || "",
    };

    setDialogueSearchFilters(normalizedFilters);

    if (!hasAnyDialogueSearchFilter(normalizedFilters)) {
      setIsDialogueSearchActive(false);
      setSearchResultCount(0);
      await loadFirstDialoguePage();
      return;
    }

    await loadSearchDialoguesPage(normalizedFilters, 1);
  };

  const handleClearDialogueSearch = async () => {
    setDialogueSearchFilters(DEFAULT_DIALOGUE_SEARCH_FILTERS);
    setIsDialogueSearchActive(false);
    setSearchResultCount(0);
    await loadFirstDialoguePage();
  };

  const nextPrevPageAPI = async (action) => {
    setPageButtonActivity(true);

    const targetPageNumber =
      action === "next" ? Number(pageNumber) + 1 : Number(pageNumber) - 1;

    if (targetPageNumber < 1 || targetPageNumber > totalPages) {
      setPageButtonActivity(false);
      return;
    }

    if (isDialogueSearchActive) {
      await loadSearchDialoguesPage(dialogueSearchFilters, targetPageNumber);
      return;
    }

    try {
      stopCurrentPageAudio();

      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: action,
        pageName: "voiceqa",
      });

      if (response.data) {
        const dialogues = await response.data.projectsArray;

        setAudioData(prepareDialogues(dialogues));
        setPageNumber(targetPageNumber);
        setPageButtonActivity(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("Error in getting the next page");
      setPageButtonActivity(false);
    }
  };

  const goToPageAPI = async (number) => {
    const targetPageNumber = Math.max(1, Number(number) || 1);

    if (isDialogueSearchActive) {
      await loadSearchDialoguesPage(dialogueSearchFilters, targetPageNumber);
      return;
    }

    setLoader(true);

    try {
      stopCurrentPageAudio();

      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: "goto",
        pageNumber: targetPageNumber,
        pageName: "voiceqa",
      });

      if (response.data) {
        const dialogues = await response.data.projectsArray;

        setAudioData(prepareDialogues(dialogues));
        setGoToPageNumber("");
        setPageNumber(targetPageNumber);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
      toast.error("Error in getting the next page");
    }
  };

  const goToPageAccordingTimeAPI = async (timeOverride) => {
    setLoader(true);

    try {
      stopCurrentPageAudio();

      const effectiveTime =
        typeof timeOverride === "number" && !Number.isNaN(timeOverride)
          ? timeOverride
          : parseFloat(currentTime) || 0;

      const positionResponse = await axios.post(
        GET_SPEECH_POSITION_AROUND_TIME,
        {
          projectId: projectFile.id,
          time: effectiveTime,
        }
      );

      const firstPosition = Math.max(
        1,
        Number(positionResponse.data?.firstPosition) || 1
      );

      const targetPage = Math.max(1, Math.ceil(firstPosition / itemsPerPage));

      const targetScrollableIndex = Math.max(
        0,
        (firstPosition - 1) % itemsPerPage
      );

      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: "goto",
        pageNumber: targetPage,
        pageName: "voiceqa",
      });

      if (response.data) {
        const dialogues = await response.data.projectsArray;

        setDialogueSearchFilters(DEFAULT_DIALOGUE_SEARCH_FILTERS);
        setIsDialogueSearchActive(false);
        setSearchResultCount(0);

        setAudioData(prepareDialogues(dialogues));
        setGoToPageNumber("");
        setPageNumber(targetPage);
        setScrollableItemLastUpdated(targetScrollableIndex);
        setScrollableItem(targetScrollableIndex);
      }

      setLoader(false);
    } catch (err) {
      setLoader(false);
      console.log(err);
      toast.error("Error in getting the next page");
    }
  };

  useEffect(() => {
    if (!projectFile?.id) {
      return;
    }

    const fetchData = async () => {
      try {
        const response = await axios.post(GET_CHARACTERS_FOR_PROJECT, {
          projectId: projectFile.id,
        });

        setCharacters(response.data.characters);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [projectFile?.id]);

  useEffect(() => {
    loadFirstDialoguePage();
  }, [loadFirstDialoguePage]);

  useEffect(() => {
    if (!syncPreview || !currentContinuousSync) {
      return;
    }

    const playCurrentDialogue = () => {
      if (currentContinuousSync.keepOriginalText) {
        const originalPlayer =
          originalAudioRefs.current[currentContinuousSync.id];
        originalPlayer?.audioEl?.current?.play();
      } else {
        const translatedPlayer =
          translatedAudioRefs.current[currentContinuousSync.id];
        translatedPlayer?.play();
      }
    };

    const playerReady = currentContinuousSync.keepOriginalText
      ? originalAudioRefs.current[currentContinuousSync.id]?.audioEl?.current
      : translatedAudioRefs.current[currentContinuousSync.id];

    if (playerReady) {
      playCurrentDialogue();
      return;
    }

    const timer = setTimeout(playCurrentDialogue, 100);

    return () => clearTimeout(timer);
  }, [currentContinuousSync, syncPreview]);

  const stopAllOtherAudio = useCallback((currentId) => {
    translatedAudioRefs.current.forEach((player, index) => {
      if (player && index !== currentId) {
        player.pause();
      }
    });

    originalAudioRefs.current.forEach((player, index) => {
      if (player && index !== currentId && player.audioEl.current) {
        player.audioEl.current.pause();
      }
    });
  }, []);

  const findPlayableIndexNear = useCallback(
    (timeSec) => {
      if (!Array.isArray(audioData) || audioData.length === 0) return null;

      const hasTranslated = (d) => {
        const tr = findTransObjectsbyLangCode(d.translations);
        return !!tr?.translatedAudio;
      };

      const hasOriginal = (d) => !!d.originalAudio;

      const isPlayable = (d) => {
        if (d.subtitleOnly === true) return false;

        if (d.keepOriginalText) return hasOriginal(d);

        return hasTranslated(d) || hasOriginal(d);
      };

      let idxNow = null;

      audioData.forEach((d, index) => {
        const start = Number(d.start);
        const end = Number(d.end);

        if (Number.isNaN(start) || Number.isNaN(end)) {
          return;
        }

        if (
          Number(timeSec) >= start &&
          Number(timeSec) < end &&
          isPlayable(d)
        ) {
          if (
            idxNow === null ||
            idxNow === undefined ||
            Number(audioData[idxNow].start) < start
          ) {
            idxNow = index;
          }
        }
      });

      if (idxNow !== null && idxNow !== undefined) return idxNow;

      const future = audioData.findIndex(
        (d) => Number(d.start) >= Number(timeSec) && isPlayable(d)
      );

      if (future !== -1) return future;

      const first = audioData.findIndex(isPlayable);

      return first !== -1 ? first : null;
    },
    [audioData, findTransObjectsbyLangCode]
  );

  const playRow = useCallback(
    (idx, resumeAt = 0) => {
      if (
        idx === null ||
        idx === undefined ||
        idx < 0 ||
        idx >= audioData.length
      ) {
        return false;
      }

      const row = audioData[idx];
      const tr = findTransObjectsbyLangCode(row.translations);
      const useOriginal = row.keepOriginalText || !tr?.translatedAudio;
      const offsetSec =
        Number.isFinite(resumeAt) && resumeAt > 0 ? resumeAt : 0;

      stopAllOtherAudio(idx);

      if (!useOriginal) {
        const p = translatedAudioRefs.current[idx];

        if (p?.play) {
          p.seek?.(offsetSec);
          p.play();
          setCurrentlyPlayingId(`translated-${idx}`);
          return true;
        }
      } else {
        const el = originalAudioRefs.current[idx]?.audioEl?.current;

        if (el) {
          el.currentTime = offsetSec;
          el.play().catch(() => {});
          setCurrentlyPlayingId(`original-${idx}`);
          return true;
        }
      }

      return false;
    },
    [audioData, findTransObjectsbyLangCode, stopAllOtherAudio]
  );

  const requestSyncPlay = useCallback(() => {
    setPlayPausePlayer("play");

    if (currentlyPlayingId) {
      const [kind, idxStr] = String(currentlyPlayingId).split("-");
      const idx = Number(idxStr);

      if (!Number.isNaN(idx)) {
        if (kind === "translated") {
          translatedAudioRefs.current[idx]?.play?.();
        } else if (kind === "original") {
          originalAudioRefs.current[idx]?.audioEl?.current?.play?.();
        }

        return;
      }
    }

    const timeSec = Number(currentTime) || 0;
    const idx = currentContinuousSync?.id ?? findPlayableIndexNear(timeSec);

    if (idx !== null && idx !== undefined) {
      const startSec = Number(audioData[idx]?.start) || 0;
      const resumeAt = Math.max(0, timeSec - startSec);

      if (playRow(idx, resumeAt)) {
        return;
      }
    }
  }, [
    audioData,
    currentContinuousSync,
    currentTime,
    currentlyPlayingId,
    findPlayableIndexNear,
    playRow,
  ]);

  const requestSyncPause = useCallback(() => {
    translatedAudioRefs.current.forEach((p) => p?.pause?.());
    originalAudioRefs.current.forEach((p) => p?.audioEl?.current?.pause?.());
    setCurrentlyPlayingId(null);
    setPlayPausePlayer("pause");
  }, []);

  const requestSyncSetSpeed = useCallback((rate) => {
    originalAudioRefs.current.forEach((p) => {
      const el = p?.audioEl?.current;

      if (el) el.playbackRate = rate;
    });

    translatedAudioRefs.current.forEach((p) => {
      if (!p) return;

      if (typeof p.setPlaybackRate === "function") {
        p.setPlaybackRate(rate);
      } else if (p.audioEl?.current) {
        p.audioEl.current.playbackRate = rate;
      }
    });
  }, []);

  const handleAudioEnded = useCallback(() => {
    if (!syncPreview) {
      setCurrentlyPlayingId(null);
      setPlayPausePlayer("pause");
      return;
    }

    setCurrentlyPlayingId(null);
    setPlayPausePlayer("play");
  }, [syncPreview]);

  useEffect(() => {
    const translatedPlayers = [...translatedAudioRefs.current];
    const originalPlayers = [...originalAudioRefs.current];

    return () => {
      translatedPlayers.forEach((player) => {
        if (player) {
          player.pause();
        }
      });

      originalPlayers.forEach((player) => {
        if (player && player.audioEl.current) {
          player.audioEl.current.pause();
        }
      });
    };
  }, []);

  const handleSubtitleOnlyChange = async (dialogueId, isSubtitleOnly) => {
    try {
      const updatedData = [...audioData];
      const dialogueIndex = updatedData.findIndex(
        (item) => item.dbid === dialogueId
      );

      if (dialogueIndex === -1) {
        toast.error("Dialogue not found");
        return;
      }

      updatedData[dialogueIndex] = {
        ...updatedData[dialogueIndex],
        subtitleOnly: isSubtitleOnly,
      };

      setAudioData(updatedData);

      setSubtitleOnlyMap({
        ...subtitleOnlyMap,
        [dialogueId]: isSubtitleOnly,
      });

      const response = await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[dialogueIndex],
      });

      if (response.data) {
        console.log(`Subtitle only status updated for dialogue ${dialogueId}`);
      }
    } catch (err) {
      console.error("Error updating subtitle status:", err);
      toast.error("Error updating subtitle status");
    }
  };

  const handleVEngineTypeChange = async (dialogueId, engineValue) => {
    try {
      const updatedData = [...audioData];
      const dialogueIndex = updatedData.findIndex(
        (item) => item.dbid === dialogueId
      );

      if (dialogueIndex === -1) {
        toast.error("Dialogue not found");
        return;
      }

      updatedData[dialogueIndex] = {
        ...updatedData[dialogueIndex],
        vEngineType: engineValue,
      };

      setAudioData(updatedData);

      setVEngineTypeMap((prev) => ({
        ...prev,
        [dialogueId]: engineValue,
      }));

      const response = await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[dialogueIndex],
      });

      if (response.data) {
        console.log(`Voice engine updated for dialogue ${dialogueId}`);
      }
    } catch (err) {
      console.error("Error updating voice engine:", err);
      toast.error("Error updating voice engine");
    }
  };

  function handleSrtTextChange(e, index) {
    const updatedData = [...audioData];

    updatedData[index].translations = updatedData[index].translations.map(
      (prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            srtText: e.target.value,
          };
        }

        return prev;
      }
    );

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);
  }

  const togglePerformanceControls = async (dialogueId, isApproved) => {
    setPerformanceCollapsedMap((prev) => ({
      ...prev,
      [dialogueId]: isApproved,
    }));

    try {
      await axios.post(SET_DIALOGUE_APPROVAL_STATUS, {
        projectId: projectFile.id,
        dialogueId,
        approved: isApproved,
        languageId: languageCode,
      });
    } catch (err) {
      console.error("Error updating approval status:", err);
      toast.error("Error updating approval status");

      setPerformanceCollapsedMap((prev) => ({
        ...prev,
        [dialogueId]: !isApproved,
      }));
    }
  };

  if (!projectFile?.id) {
    return <Loader />;
  }

  return (
    <Grid item container justifyContent="center" marginTop={1}>
      <ToastContainer position="top-center" />
      <Loader Load={audioLoader} />
      <Loader Load={loader} />

      <Grid item container xs={11.3} direction="column">
        <Grid item container direction="row">
          <PerformanceVideoPlayer
            source={videoUrl}
            syncPreview={syncPreview}
            setSyncPreview={setSyncPreview}
            playPausePlayer={playPausePlayer}
            manualPauseTick={manualPauseTick}
            seekTime={seekTime}
            displayAudioTime={displayAudioTime}
            seekTimeIndex={seekTimeIndex}
            goToPageAccordingTimeAPI={goToPageAccordingTimeAPI}
            onSyncPlay={requestSyncPlay}
            onSyncPause={requestSyncPause}
            onSyncSetSpeed={requestSyncSetSpeed}
          />

          <Grid item xs={12}>
            <DialogueSearchFilter
              value={dialogueSearchFilters}
              onChange={setDialogueSearchFilters}
              onSearch={handleDialogueSearch}
              onClear={handleClearDialogueSearch}
              characters={characters}
              emotionOptions={originalAudioEmotionOptions}
              loading={loader || pageButtonActivity}
              getSpeakerDisplayName={findDisplayName}
              originalLanguageCode={originalLanguageCode}
              translationLanguageCode={languageCode}
            />
          </Grid>

          <Grid item container xs={12}>
            <Grid
              item
              container
              className={classes["AudioWorkPlace"]}
              direction="column"
            >
              <div className={classes["AudioWorkTableWrapper"]}>
                <table className={classes["AudioWorkTable"]}>
                  <thead>
                    <tr className={classes["AudioWorkTableHeadRow"]}>
                      <th
                        className={`${classes["AudioWorkTableHeaderSpacer"]} ${classes["AudioWorkTableColumnCharacter"]}`}
                      >
                        Character
                      </th>
                      <th
                        className={`${classes["AudioWorkTableHeaderCell"]} ${classes["AudioWorkTableColumnOriginal"]}`}
                      >
                        Original
                      </th>
                      <th
                        className={`${classes["AudioWorkTableHeaderCell"]} ${classes["AudioWorkTableColumnTranslation"]}`}
                      >
                        Translation
                      </th>
                      <th
                        className={`${classes["AudioWorkTableHeaderCell"]} ${classes["AudioWorkTableColumnNewAudio"]}`}
                      >
                        Performance Direct
                      </th>
                      <th className={classes["AudioWorkTableHeaderCell"]}>
                        SRT
                      </th>
                      <th className={classes["AudioWorkTableHeaderCell"]}>
                        Notes &amp; Rating
                      </th>
                    </tr>
                  </thead>

                  <tbody
                    className={classes["AudioWorkPlaceChatBoxScroller"]}
                    ref={containerRef}
                  >
                    {audioData ? (
                      <>
                        {audioData.map((data, index) => {
                          const translation = findTransObjectsbyLangCode(
                            data?.translations
                          );

                          const translationDuration =
                            translation?.translatedAudioDuration ??
                            data?.translatedAudioDurationTemp;

                          const displayDuration = translationDuration ?? 0;

                          const durationNote = checkTranslationLength(
                            data.end - data.start,
                            translationDuration
                          );

                          const recommendedSpeedOption =
                            getRecommendedSpeedOption(
                              data.end - data.start,
                              translationDuration
                            );

                          const overlapDuration = translation?.translatedAudio
                            ? translation?.translatedAudioDuration
                            : null;

                          const translationText =
                            translation?.translatedText || "";

                          const srtText = translation?.srtText;

                          const translationNote =
                            translation?.translatedAudioNote ?? "";

                          const translationRating =
                            translation?.translatedAudioRating ?? 0;

                          const srtDisplayText =
                            srtText === undefined ||
                            srtText === null ||
                            srtText === ""
                              ? translationText
                              : srtText;

                          const isPerformanceCollapsed =
                            performanceCollapsedMap[data.dbid] ?? false;

                          const storedVoiceEngine =
                            vEngineTypeMap[data.dbid] || DEFAULT_VOICE_ENGINE;

                          const selectedVoiceEngine =
                            getSupportedVoiceEngine(storedVoiceEngine);

                          const isLegacyEngine =
                            isLegacyVoiceEngine(storedVoiceEngine);

                          const hasUnsupportedVoiceEngine =
                            !isSupportedVoiceEngine(storedVoiceEngine);

                          const isSoundEffectEngine =
                            selectedVoiceEngine === SOUND_EFFECT_VOICE_ENGINE;

                          return (
                            <tr
                              key={data.dbid || index}
                              className={classes["AudioWorkTableRow"]}
                            >
                              <td
                                className={`${classes["AudioWorkMetaColumn"]} ${classes["AudioWorkTableColumnCharacter"]}`}
                              >
                                <Grid
                                  container
                                  direction="column"
                                  gap={1.5}
                                  alignItems="stretch"
                                >
                                  <Grid
                                    item
                                    container
                                    justifyContent="center"
                                    height="25px"
                                  >
                                    {data.speaker ? (
                                      <Grid>
                                        <Select
                                          value={data.speaker}
                                          onChange={(e) =>
                                            handleSpeakerChange(e, data.id)
                                          }
                                          input={<BootstrapInputForAvalialbe />}
                                        >
                                          {characters?.map(
                                            (char, charIndex) => (
                                              <MenuItem
                                                key={charIndex}
                                                value={char.speaker}
                                                className={
                                                  classes[
                                                    "DialogueRowCharacterOption"
                                                  ]
                                                }
                                              >
                                                <span>
                                                  {findDisplayName(
                                                    char.speaker
                                                  )}
                                                </span>

                                                {!!char.projectId && (
                                                  <span
                                                    title="Imported Character"
                                                    className={
                                                      classes[
                                                        "DialogueRowImportedCharacterIndicator"
                                                      ]
                                                    }
                                                  >
                                                    ↙️
                                                  </span>
                                                )}
                                              </MenuItem>
                                            )
                                          )}
                                        </Select>
                                      </Grid>
                                    ) : (
                                      <Grid marginBottom={1}>
                                        <Select
                                          value={data.speaker}
                                          onChange={(e) =>
                                            handleSpeakerChange(e, data.id)
                                          }
                                          input={<BootstrapInput />}
                                        >
                                          {characters?.map((char) => (
                                            <MenuItem
                                              key={char.speaker}
                                              value={char.speaker}
                                              className={
                                                classes[
                                                  "DialogueRowCharacterSimpleOption"
                                                ]
                                              }
                                            >
                                              {findDisplayName(char.speaker)}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </Grid>
                                    )}
                                  </Grid>

                                  <Grid item>
                                    <InputMask
                                      mask="99:99:99.99"
                                      value={inputStartTime[index] || ""}
                                      onChange={(e) =>
                                        handleStartTimeChange(e, index)
                                      }
                                      className={`${classes["AudioWorkPlaceTimelineEditTranslation"]} ${classes["DialogueRowTimelineField"]}`}
                                      placeholder="HH:MM:SS.MS"
                                    >
                                      {(inputProps) => (
                                        <InputBase
                                          {...inputProps}
                                          fullWidth
                                          className={
                                            classes["DialogueRowTimelineInput"]
                                          }
                                        />
                                      )}
                                    </InputMask>
                                  </Grid>

                                  <Grid item>
                                    <InputMask
                                      mask="99:99:99.99"
                                      value={inputEndTime[index] || ""}
                                      onChange={(e) =>
                                        handleEndTimeChange(e, index)
                                      }
                                      className={`${classes["AudioWorkPlaceTimelineEditTranslation"]} ${classes["DialogueRowTimelineField"]}`}
                                      placeholder="HH:MM:SS.MS"
                                    >
                                      {(inputProps) => (
                                        <InputBase
                                          {...inputProps}
                                          fullWidth
                                          className={
                                            classes["DialogueRowTimelineInput"]
                                          }
                                        />
                                      )}
                                    </InputMask>
                                  </Grid>
                                </Grid>
                              </td>

                              <td
                                className={`${classes["AudioWorkDataColumn"]} ${classes["AudioWorkTableColumnOriginal"]}`}
                              >
                                <Grid container direction="column">
                                  <Grid item>
                                    <Grid
                                      item
                                      fontSize="var(--font-size-normal)"
                                      color="green"
                                    >
                                      Duration:{" "}
                                      {(data.end - data.start).toFixed(3)}
                                    </Grid>

                                    <ReactAudioPlayer
                                      className={
                                        classes["DialogueRowAudioPlayer"]
                                      }
                                      ref={(el) =>
                                        (originalAudioRefs.current[index] = el)
                                      }
                                      src={data.originalAudio}
                                      controls
                                      onPlay={() => {
                                        if (syncPreview) {
                                          setPlayPausePlayer("play");
                                        }

                                        stopAllOtherAudio(index);
                                        setCurrentlyPlayingId(
                                          `original-${index}`
                                        );
                                      }}
                                      onPause={() => {
                                        setCurrentlyPlayingId(null);

                                        if (syncPreview) {
                                          setPlayPausePlayer("pause");
                                        }
                                      }}
                                      onEnded={handleAudioEnded}
                                    />
                                  </Grid>

                                  <Grid item>
                                    <textarea
                                      className={`${
                                        classes["AudioWorkTextEditInput"]
                                      } ${
                                        currentTime >= data.start &&
                                        currentTime < data.end
                                          ? classes["DialogueRowActiveText"]
                                          : ""
                                      }`}
                                      value={data.text}
                                      type="text"
                                      onFocus={() =>
                                        handleTextFocus(index, data.start)
                                      }
                                      onChange={(e) =>
                                        handleTextChange(e, data.id)
                                      }
                                    ></textarea>
                                  </Grid>
                                </Grid>
                              </td>

                              <td
                                className={`${classes["AudioWorkDataColumn"]} ${classes["AudioWorkTableColumnTranslation"]}`}
                              >
                                <Grid container direction="row">
                                  {data.keepOriginalText ? (
                                    <></>
                                  ) : (
                                    <>
                                      <Grid item container direction="column">
                                        <Grid
                                          item
                                          fontSize="var(--font-size-normal)"
                                          color="green"
                                        >
                                          Duration: {displayDuration}
                                          {durationNote ? (
                                            <span
                                              className={
                                                classes[
                                                  "DialogueRowDurationNote"
                                                ]
                                              }
                                              style={{
                                                color: durationNote.color,
                                              }}
                                            >
                                              ({durationNote.label})
                                            </span>
                                          ) : null}
                                          {handleVoiceOverLapping(
                                            data.id,
                                            overlapDuration
                                          )}
                                        </Grid>

                                        <Grid
                                          item
                                          container
                                          direction="row"
                                          gap={1}
                                          alignItems="center"
                                        >
                                          <Grid item>
                                            <VolumeSelector
                                              value={
                                                translation?.translatedAudioVolume ??
                                                null
                                              }
                                              onChange={(e) => {
                                                handleTranslatedAudioVolume(
                                                  e,
                                                  data.id
                                                );
                                              }}
                                            />
                                          </Grid>

                                          <Grid item xs>
                                            <ClipAudioPlayer
                                              ref={(el) =>
                                                (translatedAudioRefs.current[
                                                  index
                                                ] = el)
                                              }
                                              src={translation?.translatedAudio}
                                              decible={
                                                translation?.translatedAudioVolume ??
                                                null
                                              }
                                              showScrubBar={false}
                                              onPlay={() => {
                                                if (syncPreview) {
                                                  setPlayPausePlayer("play");
                                                }

                                                stopAllOtherAudio(index);
                                                setCurrentlyPlayingId(
                                                  `translated-${index}`
                                                );
                                              }}
                                              onEnd={handleAudioEnded}
                                              onPause={() => {
                                                setCurrentlyPlayingId(null);

                                                if (syncPreview) {
                                                  setPlayPausePlayer("pause");
                                                }
                                              }}
                                            />
                                          </Grid>
                                        </Grid>

                                        <Grid item marginTop={0.6}>
                                          <textarea
                                            className={`${
                                              classes["AudioWorkTextEditInput"]
                                            } ${
                                              currentTime >= data.start &&
                                              currentTime < data.end
                                                ? classes[
                                                    "DialogueRowActiveText"
                                                  ]
                                                : ""
                                            }`}
                                            value={translationText}
                                            type="text"
                                            onFocus={() =>
                                              handleTextFocus(index, data.start)
                                            }
                                            onChange={(e) =>
                                              handleTranslationChange(
                                                e,
                                                data.id
                                              )
                                            }
                                          ></textarea>
                                        </Grid>
                                      </Grid>
                                    </>
                                  )}
                                </Grid>
                              </td>

                              <td
                                className={`${classes["AudioWorkDataColumn"]} ${classes["AudioWorkTableColumnNewAudio"]}`}
                              >
                                <Grid container direction="column" gap={1}>
                                  {isPerformanceCollapsed ? (
                                    <Grid
                                      item
                                      container
                                      justifyContent="center"
                                    >
                                      <TaskButton
                                        onClick={() =>
                                          togglePerformanceControls(
                                            data.dbid,
                                            false
                                          )
                                        }
                                        width={performanceToggleButtonWidth}
                                      >
                                        Reopen
                                      </TaskButton>
                                    </Grid>
                                  ) : (
                                    <>
                                      <Grid
                                        item
                                        container
                                        alignContent="flex-start"
                                        justifyContent="flex-start"
                                        marginTop={-2}
                                      >
                                        <Grid
                                          item
                                          container
                                          direction="row"
                                          alignItems="center"
                                          justifyContent="flex-start"
                                          marginLeft={3}
                                          wrap="nowrap"
                                          spacing={0.5}
                                        >
                                          <Grid item>
                                            <FormControlLabel
                                              className={`${classes["DialogueRowCheckboxControl"]} ${classes["DialogueRowUseOriginalControl"]}`}
                                              control={
                                                <Checkbox
                                                  checked={
                                                    data.keepOriginalText
                                                  }
                                                  size="small"
                                                />
                                              }
                                              label="Use original"
                                              onClick={() =>
                                                handleKeepOriginalText(data.id)
                                              }
                                            />
                                          </Grid>

                                          <Grid item>
                                            <FormControlLabel
                                              className={
                                                classes[
                                                  "DialogueRowCheckboxControl"
                                                ]
                                              }
                                              control={
                                                <Checkbox
                                                  checked={
                                                    subtitleOnlyMap[
                                                      data.dbid
                                                    ] || false
                                                  }
                                                  onChange={(e) =>
                                                    handleSubtitleOnlyChange(
                                                      data.dbid,
                                                      e.target.checked
                                                    )
                                                  }
                                                  size="small"
                                                />
                                              }
                                              label="Subtitle Only"
                                            />
                                          </Grid>

                                          <Grid item>
                                            <FormControl
                                              size="small"
                                              className={
                                                classes[
                                                  "DialogueRowVoiceEngineControl"
                                                ]
                                              }
                                            >
                                              <InputLabel
                                                id={`voice-engine-label-${data.id}`}
                                              >
                                                Voice Engine
                                              </InputLabel>

                                              <Select
                                                labelId={`voice-engine-label-${data.id}`}
                                                value={
                                                  hasUnsupportedVoiceEngine
                                                    ? storedVoiceEngine
                                                    : selectedVoiceEngine
                                                }
                                                label="Voice Engine"
                                                onChange={(e) =>
                                                  handleVEngineTypeChange(
                                                    data.dbid,
                                                    e.target.value
                                                  )
                                                }
                                              >
                                                {hasUnsupportedVoiceEngine && (
                                                  <MenuItem
                                                    value={storedVoiceEngine}
                                                    disabled
                                                  >
                                                    {LEGACY_AUDIO_ENGINE_LABEL}
                                                  </MenuItem>
                                                )}
                                                {VOICE_ENGINE_OPTIONS.map(
                                                  (option) => (
                                                    <MenuItem
                                                      key={option.value}
                                                      value={option.value}
                                                    >
                                                      {option.label}
                                                    </MenuItem>
                                                  )
                                                )}
                                              </Select>
                                            </FormControl>
                                            {hasUnsupportedVoiceEngine && (
                                              <div
                                                style={{
                                                  color:
                                                    "var(--color-error, #d32f2f)",
                                                  fontSize:
                                                    "var(--font-size-small)",
                                                  marginTop: 4,
                                                }}
                                              >
                                                {isLegacyEngine
                                                  ? `${LEGACY_AUDIO_ENGINE_LABEL} audio remains playable, but generation with this legacy engine is blocked. Select a supported engine to create new audio.`
                                                  : `Unsupported legacy engine "${storedVoiceEngine}" will use the default engine when generating.`}
                                              </div>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Grid>

                                      <Grid
                                        item
                                        container
                                        marginTop={-0.5}
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        alignContent="center"
                                        direction="row"
                                        gap={0.6}
                                        marginLeft={3}
                                      >
                                        {!isSoundEffectEngine && (
                                          <Grid
                                            item
                                            fontSize="var(--font-size-normal)"
                                            className={
                                              classes[
                                                "DialogueRowEmotionSelectorWrapper"
                                              ]
                                            }
                                          >
                                            {characters?.map(
                                              (char, charIndex) => (
                                                <React.Fragment key={charIndex}>
                                                  {char.speaker ===
                                                  data.speaker ? (
                                                    <select
                                                      value={
                                                        data.tempTransEmotion
                                                      }
                                                      onChange={(e) => {
                                                        const updatedData = [
                                                          ...audioData,
                                                        ];

                                                        updatedData[data.id] = {
                                                          ...updatedData[
                                                            data.id
                                                          ],
                                                          tempTransEmotion:
                                                            e.target.value,
                                                        };

                                                        setAudioData(
                                                          updatedData
                                                        );
                                                      }}
                                                      disabled={
                                                        data.keepOriginalText ||
                                                        subtitleOnlyMap[
                                                          data.dbid
                                                        ] === true
                                                      }
                                                      className={`${
                                                        classes[
                                                          "AudioWorkSelector"
                                                        ]
                                                      } ${
                                                        data.keepOriginalText ||
                                                        subtitleOnlyMap[
                                                          data.dbid
                                                        ] === true
                                                          ? classes[
                                                              "DialogueRowSelectDisabled"
                                                            ]
                                                          : ""
                                                      }`}
                                                    >
                                                      <option value="">
                                                        select emotion
                                                      </option>

                                                      {(() => {
                                                        const options = (
                                                          char.voices ?? []
                                                        ).map((voice) => ({
                                                          label: voice.emotion,
                                                          value: voice.voice_id,
                                                        }));

                                                        return options.map(
                                                          (opt, optIndex) => (
                                                            <option
                                                              value={opt.value}
                                                              key={optIndex}
                                                            >
                                                              {opt.label}
                                                            </option>
                                                          )
                                                        );
                                                      })()}
                                                    </select>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </React.Fragment>
                                              )
                                            )}
                                          </Grid>
                                        )}

                                        <Grid item xs={1.5}>
                                          <Grid
                                            item
                                            className={`${
                                              classes["DialogueRowActionIcon"]
                                            } ${
                                              data.keepOriginalText ||
                                              subtitleOnlyMap[data.dbid] ===
                                                true
                                                ? classes[
                                                    "DialogueRowActionIconDisabled"
                                                  ]
                                                : ""
                                            }`}
                                          >
                                            <Badge badgeContent={1}>
                                              <AddCircleIcon
                                                disabled={
                                                  audioLoader ||
                                                  data.keepOriginalText ||
                                                  subtitleOnlyMap[data.dbid] ===
                                                    true
                                                }
                                                onClick={() => {
                                                  if (
                                                    data.keepOriginalText ||
                                                    subtitleOnlyMap[
                                                      data.dbid
                                                    ] === true
                                                  ) {
                                                    return;
                                                  }

                                                  if (
                                                    !isSoundEffectEngine &&
                                                    audioData[data.id]
                                                      .tempTransEmotion === ""
                                                  ) {
                                                    toast.error(
                                                      "Error !! Choose an emotion"
                                                    );
                                                    return;
                                                  }

                                                  setAudioData((prevData) => {
                                                    const updatedData = [
                                                      ...prevData,
                                                    ];
                                                    updatedData[
                                                      data.id
                                                    ].loader = true;
                                                    return updatedData;
                                                  });

                                                  handleNewAudioUrl(data.id);
                                                }}
                                                className={
                                                  classes["DialogueRowAddIcon"]
                                                }
                                              />
                                            </Badge>
                                          </Grid>
                                        </Grid>

                                        {!isSoundEffectEngine && (
                                          <Grid item xs={1.5}>
                                            <Grid
                                              item
                                              className={`${
                                                classes["DialogueRowActionIcon"]
                                              } ${
                                                data.keepOriginalText ||
                                                subtitleOnlyMap[data.dbid] ===
                                                  true
                                                  ? classes[
                                                      "DialogueRowActionIconDisabled"
                                                    ]
                                                  : ""
                                              }`}
                                            >
                                              <Badge badgeContent={3}>
                                                <AddCircleIcon
                                                  disabled={
                                                    audioLoader ||
                                                    data.keepOriginalText ||
                                                    subtitleOnlyMap[
                                                      data.dbid
                                                    ] === true
                                                  }
                                                  onClick={() => {
                                                    if (
                                                      data.keepOriginalText ||
                                                      subtitleOnlyMap[
                                                        data.dbid
                                                      ] === true
                                                    ) {
                                                      return;
                                                    }

                                                    if (
                                                      audioData[data.id]
                                                        .tempTransEmotion === ""
                                                    ) {
                                                      toast.error(
                                                        "Error !! Choose an emotion"
                                                      );
                                                      return;
                                                    }

                                                    setAudioData((prevData) => {
                                                      const updatedData = [
                                                        ...prevData,
                                                      ];
                                                      updatedData[
                                                        data.id
                                                      ].loader = true;
                                                      return updatedData;
                                                    });

                                                    handleMultipleAudio(
                                                      data.id
                                                    );
                                                  }}
                                                  className={
                                                    classes[
                                                      "DialogueRowAddIcon"
                                                    ]
                                                  }
                                                />
                                              </Badge>
                                            </Grid>
                                          </Grid>
                                        )}
                                      </Grid>

                                      <Grid
                                        item
                                        container
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        alignContent="center"
                                        direction="row"
                                        gap={0.6}
                                        marginLeft={3}
                                      >
                                        <Grid
                                          item
                                          fontSize="var(--font-size-normal)"
                                        >
                                          <React.Fragment key={index}>
                                            <select
                                              className={`${
                                                classes["AudioWorkSelector"]
                                              } ${
                                                data.keepOriginalText ||
                                                subtitleOnlyMap[data.dbid] ===
                                                  true
                                                  ? classes[
                                                      "DialogueRowSelectDisabled"
                                                    ]
                                                  : ""
                                              }`}
                                              value={
                                                translation?.translatedAudio ??
                                                ""
                                              }
                                              onChange={(e) => {
                                                selectAudioOption(
                                                  e,
                                                  data.id,
                                                  index
                                                );
                                              }}
                                              disabled={
                                                data.keepOriginalText ||
                                                subtitleOnlyMap[data.dbid] ===
                                                  true
                                              }
                                            >
                                              <option value="">
                                                select options
                                              </option>

                                              {data.tempAudioList.map(
                                                (audio, audioIndex) => {
                                                  const emotionLabel =
                                                    audio.emotion ===
                                                      undefined ||
                                                    audio.emotion === null ||
                                                    audio.emotion === ""
                                                      ? ""
                                                      : `${audio.emotion} `;

                                                  return (
                                                    <option
                                                      value={audio.url}
                                                      key={audioIndex}
                                                    >
                                                      {`${audioIndex} - ${emotionLabel}(${audio.length})`}
                                                    </option>
                                                  );
                                                }
                                              )}
                                            </select>
                                          </React.Fragment>
                                        </Grid>

                                        <Grid item>
                                          <Select
                                            size="small"
                                            value={
                                              speedSelectionMap[data.dbid] ?? ""
                                            }
                                            displayEmpty
                                            onChange={(e) => {
                                              const newSpeed = e.target.value;

                                              setSpeedSelectionMap((prev) => ({
                                                ...prev,
                                                [data.dbid]: newSpeed,
                                              }));

                                              handleAdjustSpeed(data, newSpeed);
                                            }}
                                            disabled={
                                              data.keepOriginalText ||
                                              subtitleOnlyMap[data.dbid] ===
                                                true ||
                                              !translation?.translatedAudio
                                            }
                                            sx={{
                                              minWidth: "95px",
                                              height: "30px",
                                            }}
                                          >
                                            <MenuItem value="" disabled>
                                              Speed
                                            </MenuItem>
                                            <MenuItem value="auto">
                                              Auto
                                            </MenuItem>
                                            <MenuItem
                                              value={1.0}
                                              sx={{
                                                fontWeight:
                                                  recommendedSpeedOption === 1.0
                                                    ? 700
                                                    : 400,
                                              }}
                                            >
                                              Original
                                            </MenuItem>
                                            <MenuItem
                                              value={0.8}
                                              sx={{
                                                fontWeight:
                                                  recommendedSpeedOption === 0.8
                                                    ? 700
                                                    : 400,
                                              }}
                                            >
                                              Slower 20%
                                            </MenuItem>
                                            <MenuItem
                                              value={0.9}
                                              sx={{
                                                fontWeight:
                                                  recommendedSpeedOption === 0.9
                                                    ? 700
                                                    : 400,
                                              }}
                                            >
                                              Slower 10%
                                            </MenuItem>
                                            <MenuItem
                                              value={1.1}
                                              sx={{
                                                fontWeight:
                                                  recommendedSpeedOption === 1.1
                                                    ? 700
                                                    : 400,
                                              }}
                                            >
                                              Faster 10%
                                            </MenuItem>
                                            <MenuItem
                                              value={1.2}
                                              sx={{
                                                fontWeight:
                                                  recommendedSpeedOption === 1.2
                                                    ? 700
                                                    : 400,
                                              }}
                                            >
                                              Faster 20%
                                            </MenuItem>
                                          </Select>
                                        </Grid>

                                        <Grid item xs={1}>
                                          <ClipLoader
                                            color={secondaryColor}
                                            loading={false}
                                            size={25}
                                          />
                                        </Grid>

                                        <Grid item xs={1}>
                                          <ClipLoader
                                            color={secondaryColor}
                                            loading={data.loader}
                                            size={23}
                                          />
                                        </Grid>

                                        <Grid item xs={1}>
                                          <ClipLoader
                                            color={secondaryColor}
                                            loading={false}
                                            size={25}
                                          />
                                        </Grid>

                                        <Grid item>
                                          <TaskButton
                                            onClick={() =>
                                              togglePerformanceControls(
                                                data.dbid,
                                                true
                                              )
                                            }
                                            width={performanceToggleButtonWidth}
                                            height="30px"
                                            disabled={
                                              !translation?.translatedAudio
                                            }
                                          >
                                            Close
                                          </TaskButton>
                                        </Grid>
                                      </Grid>
                                    </>
                                  )}
                                </Grid>
                              </td>

                              <td className={classes["AudioWorkDataColumn"]}>
                                <Grid
                                  container
                                  direction="column"
                                  alignItems="stretch"
                                >
                                  {data.keepOriginalText ? (
                                    <></>
                                  ) : (
                                    <Grid item>
                                      <textarea
                                        className={`${
                                          classes["AudioWorkTextEditInput"]
                                        } ${
                                          currentTime >= data.start &&
                                          currentTime < data.end
                                            ? classes["DialogueRowActiveText"]
                                            : ""
                                        } ${
                                          classes["DialogueRowSrtTextInput"]
                                        }`}
                                        value={srtDisplayText}
                                        rows={5}
                                        type="text"
                                        placeholder="SRT subtitle text"
                                        onChange={(e) =>
                                          handleSrtTextChange(e, data.id)
                                        }
                                      ></textarea>
                                    </Grid>
                                  )}
                                </Grid>
                              </td>

                              <td className={classes["AudioWorkDataColumn"]}>
                                <Grid
                                  container
                                  direction="column"
                                  justifyContent="flex-start"
                                  alignItems="stretch"
                                  gap={1.5}
                                >
                                  <Grid item width="100%">
                                    <textarea
                                      className={
                                        classes["AudioWorkNoteEditInput"]
                                      }
                                      value={translationNote}
                                      placeholder="add note here"
                                      type="text"
                                      onChange={(e) =>
                                        handleNoteChange(e, data.id)
                                      }
                                    ></textarea>
                                  </Grid>

                                  <Grid item>
                                    <Rating
                                      size="small"
                                      className={classes["DialogueRowRating"]}
                                      value={translationRating}
                                      precision={1}
                                      onChange={(event, newValue) => {
                                        handleDialogueRating(newValue, data.id);
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      <></>
                    )}
                  </tbody>
                </table>
              </div>
            </Grid>

            <Grid
              item
              container
              alignItems="center"
              justifyContent="center"
              marginTop={2}
            >
              <Grid
                item
                container
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <Grid item>
                  <TaskButton
                    onClick={() => nextPrevPageAPI("previous")}
                    width="80px"
                    disabled={Number(pageNumber) === 1 || pageButtonActivity}
                  >
                    Previous
                  </TaskButton>
                </Grid>

                <Grid item>
                  <span>
                    Page {pageNumber} of {totalPages}
                  </span>
                </Grid>

                <Grid item>
                  <TaskButton
                    width="80px"
                    onClick={() => nextPrevPageAPI("next")}
                    disabled={
                      Number(pageNumber) === totalPages || pageButtonActivity
                    }
                  >
                    Next
                  </TaskButton>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              container
              alignItems="center"
              justifyContent="center"
              gap={4}
              marginTop={1}
              marginLeft={15.5}
            >
              <Grid item>
                <input
                  type="text"
                  style={{ width: "50px", textAlign: "center" }}
                  value={goToPageNumber}
                  onChange={(e) => {
                    setGoToPageNumber(e.target.value >= 1 ? e.target.value : 1);
                  }}
                />
              </Grid>

              <Grid item>
                <TaskButton
                  onClick={() => goToPageAPI(goToPageNumber)}
                  width="80px"
                >
                  Go
                </TaskButton>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            container
            xs={12}
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            marginTop={2}
            gap={3}
          >
            <Grid item xs={1}>
              <input
                style={{ width: "150px", height: "20px" }}
                className={classes["AudioWorkNoteEditInput"]}
                type="text"
                placeholder="Enter version name"
                value={versionName}
                onChange={(e) => setVersionName(formatInputs(e.target.value))}
              />
            </Grid>

            <Grid item>
              <TaskButton onClick={() => finalSubmission()}>
                Submit All
              </TaskButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default VideoPerformanceDirection;
